<template>
    <div class="detail">
        <div class="content" v-html="content"></div>
        <div class="share">
            <a :href="xinlangHref" target="_blank" class="xinlang"></a>
            <div class="weixin" @click="toggleQrCode">
                <div v-show="isWeixinActive" class="qr-code-popup">
                    <img src="@/assets/images/footer/erweima.jpg" alt="二维码图片" />
                </div>
            </div>
            <a :href="qqHref" target="_blank" class="qq"></a>
            <a :href="doubanHref" target="_blank" class="douban"></a>
        </div>
    </div>
</template>

<script>
import ajax from '@/api/ajax'
import { ajaxMap } from './config'
export default {
    name: 'YearDetail',
    data() {
        return {
            content: '',
            module: '',
            title: '',
            isWeixinActive: false
        }
    },
    computed: {
        xinlangHref() {
            return `http://v.t.sina.com.cn/share/share.php?url=${window.location.href}&title=${this.title}`
        },
        qqHref() {
            return `http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${window.location.href}&title=${this.title}`
        },
        doubanHref() {
            return `http://shuo.douban.com/!service/share?href=${window.location.href}&title=${this.title}`
        }
    },
    async created() {
        const id = this.$route.query.id
        this.module = this.$route.meta.module
        const { content, title } = await this.getList(id)
        this.title = title
        this.content = content
    },
    methods: {
        toggleQrCode() {
            this.isWeixinActive = !this.isWeixinActive
        },
        async getList(id) {
            if (!id) {
                return {}
            }
            const params = {
                id
            }
            const result = await ajax[ajaxMap.get(this.module)]({
                params
            })
            if (result) {
                return result[0]
            } else {
                return {}
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    padding: 0.2rem;
    >>> img {
        max-width: 100%;
        height: auto;
    }
    >>> .image {
        text-align: center;
        margin: 0;
    }
    >>> figure {
        margin: 0;
        td {
            border: 1px solid #ccc;
        }
    }
}
.share {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    a,
    & > div {
        width: 80px;
        height: 80px;
        background-size: 80% 80%;
        background-repeat: no-repeat;
        background-position: center center;
    }
    .xinlang {
        background-image: url('~@/assets/images/yearContent/xinlang_black.png');
    }
    .weixin {
        position: relative;
        background-image: url('~@/assets/images/yearContent/weixin_black.png');
    }
    .qq {
        background-image: url('~@/assets/images/yearContent/qq_black.png');
    }
    .douban {
        background-image: url('~@/assets/images/yearContent/douban_black.png');
    }
    .qr-code-popup {
        width: 300px;
        height: 300px;
        position: absolute;
        top: -300px;
        right: -110px;
        background: url('~@/assets/images/footer/qr-code-popup.png') center center no-repeat;
        background-size: 3rem 4rem;
        img {
            display: block;
            padding: 20px;
            width: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/year-content/detail.vue